import request from "../../request";

export const storeAdd = (params: any) => request.post('/rental/scm/store/add', params);

export const getStoreDetail = (params: any) => request.get('/rental/scm/store/detail', { params });

export const storeCheckName = (params: any) => request.post('/rental/scm/store/checkName', params);

export const storeUpdateStatus = (params: any) => request.post('/rental/scm/store/updateStatus', params);

export const storeUpdate = (params: any) => request.post('/rental/scm/store/update', params);

export const getRestScheduleList = (params: any) => request.get('/rental/scm/store/restSchedule/listPage', { params });

export const addStoreRestDay = (params: any) => request.post('/rental/scm/store/restSchedule/add', params);

export const restScheduleUpdateStatus = (params: any) => request.post('/rental/scm/store/restSchedule/updateStatus', params);

export const storeWebsiteAdd = (params: any) => request.post('/rental/scm/store/website/add', params);

export const storeWebsiteUpdate = (params: any) => request.post('/rental/scm/store/website/update', params);

export const getStoreWebsiteList = (params: any) => request.get('/rental/scm/store/website/listPage', { params });

export const storeWebsiteCheckName = (params: any) => request.post('/rental/scm/store/website/checkName', params);

export const updateWebsiteStatus = (params: any) => request.post('/rental/scm/store/website/updateStatus', params);

export const sameCityPRCarOpen = (params: any) => request.post('/rental/scm/supplier/sameCityPRCar/active', params);

export const getSameCityPRCarDetail = (params: any) => request.get('/rental/scm/supplier/sameCityPRCar/get', { params });

export const sameCityPRCarCancel = (params: any) => request.post('/rental/scm/supplier/sameCityPRCar/cancel', params);

export const getDiffCityPRCarLineList = (params: any) => request.get('/rental/scm/supplier/diffCityPRCarLine/listPage', { params });

export const diffCityPRCarLineUpdateStatus = (params: any) => request.post('/rental/scm/supplier/diffCityPRCarLine/updateStatus', params);

export const diffCityPRCarLineUpdate = (params: any) => request.post('/rental/scm/supplier/diffCityPRCarLine/update', params);

export const diffCityPRCarLineAdd = (params: any) => request.post('/rental/scm/supplier/diffCityPRCarLine/add', params);

export const getCityList = (params: any) => request.get('/rental/scm/store/filterItem', { params });

export const getWebsiteDetail = (params: any) => request.get('/rental/scm/store/website/detail', { params });

export const serviceAreaAddOrUpdate = (params: any) => request.post('/rental/scm/store/serviceArea/addOrUpdate', params);

export const getDiffCityList = (params: any) => request.get('/rental/scm/supplier/diffCityPRCarLine/filterItems', { params });
